import { Component } from '@angular/core'
import { OauthCallbackComponent } from '../oauth-callback.component'

@Component({
    selector: 'facebook-oauth-callback',
    templateUrl: '../oauth-callback.component.html',
    styleUrls: ['../oauth-callback.component.css'],
})
export class GoogleOauthCallbackComponent extends OauthCallbackComponent {
    ngOnInit() {
        this.socialType = 'google'
        super.ngOnInit()
    }
}
